import { connect, MapStateToProps } from 'react-redux'
import { Props } from './VinAlternativesModal'
import { createVehicleCode } from '../../redux/actions/app/vehicleCode.actions'
import brandSelector from '../../redux/selectors/brandSelector'
import vinStatusDataSelector from '../../redux/selectors/vinStatusDataSelector'
import { loadConfigurationByVin, resetVinData } from '../../redux/actions/app/vin.actions'
import { loadConfigurationByPrString } from '../../redux/actions/app/prString.actions'
type StateProps = Pick<Props, 'vinDataStatus' | 'brand'>

const mapStateToProps: MapStateToProps<StateProps, {}> = (state): StateProps => ({
    vinDataStatus: vinStatusDataSelector(state),
    brand: brandSelector(state),
})

type DispatchProps = Pick<Props, 'createVehicleCode' | 'resetVinData' | 'loadConfigurationByVin' | 'loadConfigurationByPrString'>

const mapDispatchToProps: DispatchProps = {
    createVehicleCode,
    resetVinData,
    loadConfigurationByVin,
    loadConfigurationByPrString,
}

export default connect(mapStateToProps, mapDispatchToProps)
